import * as React from "react";

import { EventItem } from './EventsListingResult';

const FeaturedEvent = (props: {
    item: EventItem,
    className?: string;
}) => {

    const combineWithCommas = (data: string[]) => {

        const filtered = data.filter(x => x && (x.trim().length > 0));
        return filtered.join(', ');
    }

    // return
    return <div className={"featured-event-card " + props.className}>
        <div className="card-header">Featured Event</div>

        {props.item.Thumbnail &&
            <a href={props.item.Url} className="img-wrap">
                <img className="card-img-top" src={props.item.Thumbnail} alt={props.item.ThumbnailAlt} />
            </a>
        }
        <div className="card-body">
            <div className="category-sticker mb-2" style={{
                backgroundColor: props.item.Category ? props.item.Category.BackgroundColor : '',
                color: props.item.Category ? props.item.Category.TextColor : ''
            }} hidden={!props.item.Category}>
                {props.item.Category ? props.item.Category.Name : ''}
            </div>
            <a className="card-title mb-2" href={props.item.Url} dangerouslySetInnerHTML={{ __html: props.item.Title }}>
            </a>
            <div className="mt-3 mb-1 date">
                <img src="/images/icons/icon-date.svg" width="24" height="24" alt="Date" /><span className="pl-2">Date</span>
            </div>
            {!props.item.DateToBeAnnounced &&
                <div className="date-string" dangerouslySetInnerHTML={{ __html: props.item.DateString }}>
                </div>
            }
            {props.item.DateToBeAnnounced &&
                <div className="date-string">
                Date to be announced
                </div>
            }
            
            <div className="mt-3 mb-2 map">
                <img src="/images/icons/icon-venue.svg" width="24" height="24" alt="Venue"/><span className="pl-2">Venue</span>
            </div>
            <div className="venue" dangerouslySetInnerHTML={{ __html: props.item.Venue }}>

            </div>

            <div className="mb-3" dangerouslySetInnerHTML={{ __html: combineWithCommas([props.item.Address, props.item.City, `${props.item.Province} ${props.item.Postal}`]) }}>

            </div>

            {props.item.Audience && props.item.Audience.length > 0 &&
                <div className="mt-3 mb-3">
                    <span className="map">Audience</span>
                    <div dangerouslySetInnerHTML={{ __html: props.item.Audience }}>
                    </div>
                </div>
            }

            <a className="btn btn-primary d-block" href={props.item.RegisterUrl} target={props.item.RegisterUrlNewWindow ? "_blank" : ''}>Register Now</a>

            {/*
            <div className="d-flex justify-content-center mt-2">                
                <div className="addthis_toolbox d-inline" data-addthis-url={props.item.Url} data-addthis-title={props.item.Title}>
                    <span className="custom_images">
                        <a className="addthis_button_more"><span className="btn-share">Share</span></a>
                    </span>
                </div>
            </div>
            */}
        </div>
    </div>
}

export default FeaturedEvent;